import type { EmblemId } from '@/lib/client-roster';

type Props = {
  id: EmblemId;
  size?: number;
  className?: string;
};

export function ClientEmblem({ id, size = 14, className }: Props) {
  switch (id) {
    case 'tablesharp':
      return <TableSharpEmblem size={size} className={className} />;
    case 'fetti':
      return <FettiEmblem size={size} className={className} />;
    case 'powderledger':
      return <PowderLedgerEmblem size={size} className={className} />;
  }
}

function TableSharpEmblem({ size, className }: { size: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="ts-emblem-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#a855f7" />
          <stop offset="1" stopColor="#ec4899" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="18" height="18" rx="4" fill="url(#ts-emblem-grad)" />
      <path
        d="M12 7.5l3.2 3.2-3.2 3.2-3.2-3.2 3.2-3.2zM8 14.5h8"
        stroke="#fff"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FettiEmblem({ size, className }: { size: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="fetti-emblem-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f59e0b" />
          <stop offset="1" stopColor="#ef4444" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="18" height="18" rx="4" fill="url(#fetti-emblem-grad)" />
      <path
        d="M9 7v10M9 7h5.5M9 12h4"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function PowderLedgerEmblem({ size, className }: { size: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="pl-emblem-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0ea5e9" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="18" height="18" rx="4" fill="url(#pl-emblem-grad)" />
      <path
        d="M5 17l4-7 3 4 3-5 4 8"
        stroke="#fff"
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
